<script lang="ts">
    
    import { createEventDispatcher, getContext, onDestroy, onMount } from "svelte";
    import { Map as Mapbox, Marker } from 'mapbox-gl';
    import type { MilestoneDto } from "../../global";

    export let milestone: MilestoneDto;

    const dispatch = createEventDispatcher();
    const getMapbox = getContext('getMapbox') as () => Mapbox;

    let marker: Marker;

    onMount(() => {
        const element = document.createElement('div') as HTMLElement;
        element.classList.add('milestone-marker');
        element.addEventListener('click', onClick);

        marker = new Marker({
            element,
            anchor: 'bottom',
        });

        marker.setLngLat(milestone.position);
        marker.addTo(getMapbox());
    });

    onDestroy(() => {
        marker?.remove();
    });

    function onClick(): void {
        dispatch('click', milestone);
    }
    
</script>

<style lang="scss">

    :global(.milestone-marker) {
        --size: 20px;

        box-sizing: border-box;
        width: var(--size);
        height: var(--size);
        background-color: #2a98d8;
        border: 2px solid #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
        border-radius: 50%;
    }

</style>
